import React, {useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";
import IconCanceled from "../iconComponents/IconCanceled";
import IconWait from "../iconComponents/IconWait";
import IconIndicator from "../iconComponents/Indicator";
import IconTick from "../iconComponents/IconTick";
import IconWarning from "../iconComponents/IconWarning";
import InvoiceActionInstruction from "./InvoiceActionInstruction";
import { formatDateTimeToZone } from "../common/Helpers";

export function InvoiceActionRequired(props) {

const invoice = useSelector(state => state.invoices.invoice);
const currentUser = useSelector( (state) => state.auth.user);

const userIsResponsible = invoice.party_responsible ? (invoice.party_responsible.filter((party) => party.email === currentUser.email).length > 0) : false;

const partyResponsibleRole = {
    REV: "Purchasing company",
    REJ: "Vendor company",
    CA: "Vendor company",
    PR: "Purchasing company",
    PU: "Vendor company"
}

const getExternalEmail = () => {
    if (!invoice.contract_shared) {
        if (currentUser.email === invoice.VCA.email) {
            return invoice.PCA.email;
        } else if (currentUser.email === invoice.PCA.email) {
            return invoice.VCA.email;
        }
    } else return null;
}

    return (
        <div>
            {invoice.contract_shared 
                ?<>
                    {invoice.party_responsible 
                        ?<>
                            {userIsResponsible 
                            ?<IconIndicator height="12px" svgClass="iblock gap-right-xs" style={{marginBottom: "-2px"}} pathClass="p-fill" />
                            :<IconWait height="14px" className="iblock gap-right-xs" style={{marginBottom: "-2px"}} pathClass="g5-fill" />
                            }
                            {invoice.party_responsible.map((party, index) => {
                                return (
                                    <div key={index} className="content1 iblock">{`${party.first_name ? party.first_name : party.email} ${party.last_name}${index < invoice.party_responsible.length - 1 && invoice.party_responsible.length > 1 ? "or " : ""}${index < invoice.party_responsible.length - 1 ? ", " : ""}`}</div>
                                )
                            })}
                        </> 
                        :<>
                            {(invoice.invoice_status === "Pending" || invoice.invoice_status === "Active")
                                ?<>
                                    <IconWarning height="14px" className="iblock gap-right-xs" style={{marginBottom: "-2px"}} pathClass="red-dark-fill" />
                                    <div className="content1 iblock" >{partyResponsibleRole[invoice.stage]} must assign a user</div>
                                </>
                                :<div className="content1 iblock" >None</div>
                            }
                        </>
                    }
                </>
                :<>
                    {userIsResponsible 
                    ?<>
                        <IconIndicator height="12px" svgClass="iblock gap-right-xs" style={{marginBottom: "-2px"}} pathClass="p-fill" />
                        {invoice.party_responsible.map((party, index) => {
                            return (
                                <div key={index} className="content1 iblock">{`${party.first_name} ${party.last_name}${index < invoice.party_responsible.length - 1 && invoice.party_responsible.length > 1 ? "or " : ""}${index < invoice.party_responsible.length - 1 ? ", " : ""}`}</div>
                            )
                        })}
                    </>
                    :<>
                        <IconWait height="14px" className="iblock gap-right-xs" style={{marginBottom: "-2px"}} pathClass="g5-fill" />
                        <div className="content1 iblock">{getExternalEmail()}</div>
                    </>
                    }
                </>
            }

            <InvoiceActionInstruction setRejModalOpen={props.setRejModalOpen} />
            {invoice.stage === "PC" && <h4 className="content2 light-black nextsteps iblock"> {formatDateTimeToZone(invoice.payment_confirmed_date)}</h4> }
            {invoice.stage === "CA" && <h4 className="content2 light-black nextsteps iblock">Cancelled {formatDateTimeToZone(invoice.cancelled_date)}</h4>}
        </div>
    )
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps)(InvoiceActionRequired);